import { backendFetch } from '../apiUtils';

export const confirmUsingAuthentication = async (data) => {
  const documentResponse = await backendFetch({
    url: 'v2/vatAuth',
    options: {
      body: JSON.stringify(data),
      headers: { 'Content-Type': 'application/json' },
    },
    method: 'POST',
  });
  return documentResponse.data;
};
